import "./Header.scss";
import Menu from "../Menu/Menu";

const Header = () => {
  return (
    <header>
      <Menu />
      <h2>We are creatives</h2>
    </header>
  );
};

export default Header;
